/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function RocketNoAstronaut(props) {
  const { nodes, materials } = useGLTF('/models/rocket-no-astronaut.glb')
  return (
    <group {...props} dispose={null}>
      <group
        position={[-0.015, 1.801, -0.129]}
        rotation={[-Math.PI, Math.PI / 4, -Math.PI]}
        scale={0.052}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle033.geometry}
          material={materials['Ship White']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle033_1.geometry}
          material={materials['Ship red']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle033_2.geometry}
          material={materials['Alien Black']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle009.geometry}
          material={materials['Ship red']}
          position={[0.008, -48.617, 12.536]}
          rotation={[0.009, -1.571, 0]}
          scale={[1.225, 1.376, 1.225]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle011.geometry}
          material={materials['Ship red']}
          position={[12.544, -48.617, 0]}
          rotation={[0, 0, -0.009]}
          scale={[1.225, 1.376, 1.225]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle012.geometry}
          material={materials['Ship red']}
          position={[-6.703, -24.668, -6.925]}
          rotation={[0.806, -0.595, 2.119]}
          scale={18.152}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane002.geometry}
          material={materials['Ship red']}
          position={[0.008, -43.911, 6.028]}
          rotation={[0.702, 0, Math.PI / 2]}
          scale={13.763}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane003.geometry}
          material={materials['Ship red']}
          position={[6.036, -43.911, 0]}
          rotation={[Math.PI / 2, 0.869, 0]}
          scale={13.763}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/rocket-no-astronaut.glb')
